import Vue from "vue";
import Vuex from "vuex";
import {HTTP} from "../axios";

import {
  ACCEDE_EVTS,
  ACCEDE_SEN_PAR_MATRICULE, ACCEDE_SENS_DISPOS, ACCEDE_TYPURL_PAR_CODE, CHARGE_EVTS_PAR_MATRICULE, CHARGE_SENS_DISPOS,
  CHARGE_TYPURLS,
  MODIFIE_EVTS,
  MODIFIE_SENS_DISPOS, MODIFIE_TYPURLS
} from "./types";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    senateurs: [],
    typUrls: [],
    events: []
  },
  getters: {
    [ACCEDE_SENS_DISPOS]: state => {
      return state.senateurs;
    },
    [ACCEDE_SEN_PAR_MATRICULE]: (state, getters) => (matricule) => {
      return getters[ACCEDE_SENS_DISPOS].find(s => s.matricule === matricule);
    },
    [ACCEDE_TYPURL_PAR_CODE]: (state, getters) => (code) => {
      return state.typUrls.find(t => t.code === code);
    },
    [ACCEDE_EVTS]: (state, getters) => () => {
      return state.events;
    }
  },
  mutations: {
    [MODIFIE_SENS_DISPOS]: (state, payload) => {
      state.senateurs = payload;
    },
    [MODIFIE_TYPURLS]: (state, payload) => {
      state.typUrls = payload;
    },
    [MODIFIE_EVTS]: (state, payload) => {
      state.events = payload;
    }
  },
  actions: {
    [CHARGE_SENS_DISPOS]: async ({commit, state}) => {
      if((undefined !== state.senateurs) && (0 < state.senateurs.length)) {
        console.log("Liste des Sénateurs déjà chargée");
        return;
      }
      let response = await HTTP.get("liste_actifs.json");
      let sens = response.data;
      // le premier élément contient nom, prénom
      sens.shift();
      commit(MODIFIE_SENS_DISPOS, sens);
    },
    [CHARGE_TYPURLS]: async ({commit}) => {
      let response = await HTTP.get("liste_typurls.json");
      let typurls = response.data;
      commit(MODIFIE_TYPURLS, typurls);
    },
    [CHARGE_EVTS_PAR_MATRICULE]: async ({commit, state}, matricule) => {
      console.log(`Chargement des données du matricule ${matricule}`);
      if((undefined !== state.events) && (matricule in state.events)) {
        // déjà chargé
        console.log("Les données sont déjà chargées");
        let donnees = state.events[matricule];
        commit(MODIFIE_EVTS, []);
        commit(MODIFIE_EVTS, donnees);
        return;
      }
      let response = await HTTP.get(`sen_${matricule}.json`);
      let evts = response.data;
      commit(MODIFIE_EVTS, evts);
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js